import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { PromoBanner } from "@/components/landing/PromoBanner";
import { Presentation } from "@/components/landing/Presentation";
import { Services } from "@/components/landing/Services";
import { Vehicles } from "@/components/landing/Vehicles";
import { Avis } from "@/components/landing/Avis";
import { Faq } from "@/components/landing/Faq";
import { Horaires } from "@/components/landing/Horaires";
import { ContactForm } from "@/components/landing/ContactForm";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (id) => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(id, { offset: -64, duration: 1.4 });
    }
  };

  return (
    <div className="bg-[#07090E] text-[#F8FAFC] min-h-screen overflow-x-clip">
      <Navbar onNavigate={scrollTo} />
      <main>
        <Hero onNavigate={scrollTo} />
        <Marquee />
        <PromoBanner onNavigate={scrollTo} />
        <Presentation />
        <Services />
        <Vehicles />
        <Avis />
        <Faq />
        <Horaires />
        <ContactForm />
      </main>
      <Footer onNavigate={scrollTo} />
    </div>
  );
}
